export default __webpack_public_path__ + "static/media/goshen19.94bb7e97.jpg";